import { SupplierRegistrationCountryFields } from '@supplierRegistration/domain/supplierRegistrationCountryFields';

enum NetherlandsLegalIdTypesForCompany {
  VAT = 'VAT',
  KVK = 'KVK',
  Other = 'Other',
}

export const NL: SupplierRegistrationCountryFields = {
  leis: { types: NetherlandsLegalIdTypesForCompany },
};
